// I've almost figured out how to do polymorphic components correctly, but then gave up
// and just stole this from https://mantine.dev/guides/polymorphic/
// also changed it a bit, here's original:
// https://github.com/mantinedev/mantine/blob/d37666f12296741d894f036a9d9b3d0c8f4d4670/src/mantine-utils/src/create-polymorphic-component/create-polymorphic-component.ts

import React, {CSSProperties} from 'react';

type ElementType = keyof React.JSX.IntrinsicElements | React.JSXElementConstructor<any>;

type PropsOf<E extends ElementType> = React.JSX.LibraryManagedAttributes<E, React.ComponentPropsWithoutRef<E>>;

type Override<T, U> = U & Omit<T, keyof U>;

export type PolymorphicProps<E, Props = {}> = E extends React.ElementType
    ? Override<PropsOf<E>, Props & {as?: E}> & {ref?: PolymorphicRef<E>}
    : Props & {as: React.ElementType};

export type PolymorphicRef<C> = C extends React.ElementType ? React.ComponentPropsWithRef<C>['ref'] : never;

export interface PolymorphicComponent<ComponentDefaultType, Props> {
    <C = ComponentDefaultType>(props: PolymorphicProps<C, Props>): React.ReactElement;

    displayName?: string;
}

export const createPolymorphicComponent =
    <DefaultType extends keyof React.JSX.IntrinsicElements>(defaultType: DefaultType) =>
    <Props>(component: (props: Props) => React.ReactNode) =>
        Object.defineProperty(component, 'defaultProps', {
            value: {as: defaultType},
            writable: false,
        }) as PolymorphicComponent<DefaultType, Props>;

interface PolyElementProps {
    children?: React.ReactNode;
    className?: string;
    style?: CSSProperties;
}

export const PolyElementBase = ({
    as: Element,
    ...rest
}: PolyElementProps & {
    as?: any;
}) => React.createElement(Element || 'div', rest);
PolyElementBase.displayName = 'PolyElementBase';

export const PolyElement = createPolymorphicComponent('div')<PolyElementProps>(PolyElementBase);
